import { Action } from 'redux';

import { LaunchRevisionHistory } from '../../bootstrap/redux/actions/AppActionTypes';
import { isActionFactory } from '../../bootstrap/redux/actions/isActionFactory';
import { IContentInfo } from '../../spacesPlatform/models/IContentInfo';

export interface RevisionHistoryAction extends Action {
  content: IContentInfo;
}

export function launchRevisionHistory(content: IContentInfo): RevisionHistoryAction {
  return {
    type: LaunchRevisionHistory,
    content
  };
}

export const isRevisionHistoryAction = isActionFactory<RevisionHistoryAction>(LaunchRevisionHistory);
